import messageContentParser from './MessageContentParser';
import { parseToolEvents } from './parsers/toolEventParser';

/**
 * Sanitizes message text by removing all tool-related syntax and extracting only visible text
 * @param {string} messageText - The raw message text containing tool syntax
 * @returns {string} - Clean text without any tool markers or syntax
 */
export function sanitizeMessageText(messageText) {
  if (!messageText) return '';

  // First, remove tool event markers
  const { cleanText } = parseToolEvents(messageText);

  // Parse the content to extract text parts only
  const parsedContent = messageContentParser.parseContent(cleanText);

  // Extract only text parts and join them
  const textParts = parsedContent
    .filter((part) => part.type === 'text')
    .map((part) => part.content)
    .join(' ');

  // Clean up extra whitespace
  return textParts.replace(/\s+/g, ' ').trim();
}
